var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-app",
    { staticStyle: { "font-family": "NeueMontreal" } },
    [
      _c("v-main", { style: _vm.computedStyle }, [_c("router-view")], 1),
      _vm._v(" "),
      _c("Toaster"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }